<template>
	<header-block title="Recommended Discounts"></header-block>

	<v-row class="topMenuRow">
		<v-col class="topMenuCol">
			<v-btn :class="['topTabButton', { selected: daysBack === -60 }]" title="" @click="setDaysBack(-60)">Last Month</v-btn>
		</v-col>
		<v-col class="topMenuCol">
			<v-btn :class="['topTabButton', { selected: daysBack === -365 }]" title="" @click="setDaysBack(-365)">Past Year</v-btn>
		</v-col>
	</v-row>

	<div v-if="!loading && totalSavings > 0" class="couldHaveSaved centered mb-4">
		<p class="couldHaveSavedText">In <span class="month">{{ periodString }}</span> you could have saved</p>
		<p class="couldHaveSavedAmount">£{{ totalSavings.toFixed(2) }}</p>
	</div>

	<div class="mt-6" v-if="recommendedVouchers">
		<VoucherList
		:showAll="true" 
		:vouchers="recommendedVouchers" 
		:search="false" 
		:showSaving="true" 
		:showFavourites="true"
		:spendLabel="'Your'" 
		:showLastMonthSpend="daysBack === -60"
		@favouriteToggled="(v) => { favouriteToggled(v); }"
		:formatter="formatter" />
	</div>
	<div class="mt-6" v-else>
		<div v-for="i in 8" :key="i" class="mb-2">
			<v-skeleton-loader
				type="list-item-avatar-two-line"
			></v-skeleton-loader>
		</div>
	</div>

	<p v-if="!loading && recommendedVouchers.length==0" class="centered">
		Sorry, we do not have any recommendations for {{ periodString }}.
	</p>

	<div style="clear:both; "></div>	
</template>

<script>
import Services from '../mixins/Services';
import HeaderBlock from './elements/HeaderBlock.vue';
import VoucherList from './elements/VoucherList.vue';

export default {
	mixins: [Services],
	components: {HeaderBlock, VoucherList},
	data() {
		return {
			recommendedVouchers: null,
			daysBack: -60, 
			loading: true,
			periodString: '',
			totalSavings: 0,
		}
	},
	methods: {
		setDaysBack: function(days) {
			this.daysBack = days;
			this.loading = true;
			this.recommendedVouchers = null;
			this.loadRecommended();
		},
		onLoad: async function() {
			this._getCustomer();
			this.loadRecommended();
		},
		loadRecommended: function(){
			this._getRecommendedVouchers(this.daysBack, (r) => {
				console.log(r);
				if (this.daysBack === -60)
				{
					r = r.filter(v => {
						return v.lastMonthSpend && Math.abs(v.lastMonthSpend) > 0;
					});
					r.forEach(v => {
						v.saving = Math.abs(v.lastMonthSpend * (v.effectiveDiscountPercentage / 100));
					});
					const lastMonth = new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1);
					this.periodString = lastMonth.toLocaleString('default', { month: 'long' });
				}
				else {
					this.periodString = 'the past year';
				}
				console.log('Recommended vouchers:', r);
				this.recommendedVouchers = r;
				this.totalSavings = r.reduce((sum, v) => sum + (v.saving || 0), 0);
				this.loading = false;
			});
		},
		favouriteToggled: function(voucher) {
			if (voucher.favourite) {
				this._removeCustomerFavouriteDiscount(voucher, () => {
					voucher.favourite = !voucher.favourite;
				});
			} else {
				this._addCustomerFavouriteDiscount(voucher, () => {
					voucher.favourite = !voucher.favourite;
				});
			}
		},
	},
	mounted: function () {
		this.onLoad();
	},
}
</script>

<style scoped>

.topTabButton
{
	margin-top: 0px;
	text-transform: none;
	padding-top: 17px !important;
	padding-bottom: 30px !important;
	vertical-align: middle !important;
	background-color: #ffffff66 !important;
	font-weight: bold;
}

.topTabButton.selected {
    background-color: var(--text-color) !important;
	color: white !important;
}

.topMenuCol {
	padding-left: 3px;
	padding-right: 3px;
}

.topMenuRow
{
	margin-left: -5px;
	margin-right: -5px;
	margin-bottom: 15px;
}

.couldHaveSaved {
	background: linear-gradient(358.65deg, #F7F4F0 0.56%, #FAF8F5 101.36%);
	padding: 20px 20px;
	margin-left: -30px;
	margin-right: -30px;
}

.couldHaveSavedText {
	font-size: 13px;
	margin: 0;
}
.couldHaveSavedAmount {
	font-size: 32px;
	font-weight: bold;
	margin: 0;
}
.month {
	background: #E1C6C8;
	padding: 2px 6px;
	border-radius: 4px;
}

</style>
